import React, { FC } from 'react'
import { TableColumn } from 'react-data-table-component'

import InfiniteScrollDataTable from '../../../components/common/tables/InfiniteScrollDataTable'
import { IconEmpty } from '../../../components/icons/IconEmpty'

import { ALL_CLASSES, EStatuses } from './hooks/useManageClinicNOtherAdminTabNew'
import { IRider } from '../../../types/entryRider'

interface ManageEntriesProps {
  draftRiders: IRider[]
  filteredRiders: IRider[]
  activeStatus: { value: string; label: string } | null
  activeClass: { value: string; label: string }
  tableColumns: TableColumn<IRider>[]
}
export const ManageEntries: FC<ManageEntriesProps> = ({
  draftRiders,
  activeStatus,
  filteredRiders,
  activeClass,
  tableColumns,
}) => {
  return (
    <>
      {activeStatus?.value !== EStatuses.draft && (
        <InfiniteScrollDataTable
          hasMore={false}
          className="z-10"
          columns={tableColumns}
          data={filteredRiders}
          noDataComponent={
            !draftRiders[0] &&
            !filteredRiders[0] && (
              <div className={'min-h-[65vh] flex items-center justify-center flex-col gap-[36px]'}>
                <IconEmpty />
                <p className={'text-center m-0 text-[#122B46] text-[16px]'}>
                  No horses have registered for this event
                </p>
              </div>
            )
          }
        />
      )}

      {activeClass.value === ALL_CLASSES.value &&
        (!activeStatus?.value ||
          activeStatus?.value === EStatuses.all ||
          activeStatus?.value === EStatuses.draft) &&
        draftRiders[0] && (
          <>
            {activeStatus?.value !== 'Draft' && (
              <div className={'h-[1px] w-full bg-gray-500 my-4'}></div>
            )}

            <InfiniteScrollDataTable
              hasMore={false}
              columns={tableColumns}
              noTableHead={true}
              data={draftRiders}
              noDataComponent={null}
            />
          </>
        )}
    </>
  )
}
